import { render, staticRenderFns } from "./matrixSpike.vue?vue&type=template&id=38b3b9b4&scoped=true&"
import script from "./matrixSpike.vue?vue&type=script&lang=js&"
export * from "./matrixSpike.vue?vue&type=script&lang=js&"
import style0 from "./matrixSpike.vue?vue&type=style&index=0&id=38b3b9b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b3b9b4",
  null
  
)

export default component.exports